// import axios from 'axios';
// import RESTCall from "./restApi";
// import axios from "axios";
// import Constants from "expo-constants";
// import environment from "../components/environment";
import moment from "moment";

// const env = environment("staging");
// const string = env.restApi;

//wild search document
// http://localhost:5000/vareapp/search/
//post
// {
//     "key": ["group","number"],
//     "doc":"vare_chats",
//     "search":"51234453322"
// }

//delete document
// http://localhost:5000/vareapp/delete/
//post
// {
//     "key":["item_id","user_id"],
//     "doc":"vare_vote",
//     "data": [
//         {
//             "user_id": "Shavae2006@yahoo.com",
//             "item_id": "hr6760-116",
//             "keyName": "hhhhhh"
//         }
//     ]
// }

//group votes and count response
//endppoint: http://localhost:5000/vareapp/votes
//type: post
// {
//     "doc":"vare_vote",
//     "data": ["hr6760-116","ccxxxhhhhhh","P60012143_voteMeIn"]
// }

//find all document
//endppoint: http://localhost:5000/vareapp/find/
//type: post
// {
//     "doc":"vare_vote",
//     "data": [
//         {"user_id":"Shavae2006@yahoo.com","item_id":"hr6760-116"}
//     ]
// }

//search with query document
//endppoint: http://localhost:5000/vareapp/find/
//type: post
// {
//     "doc":"vare_vote",
//     "data": [
//         {"user_id":"Shavae2006@yahoo.com","item_id":"hr6760-116"}
//     ]
// }

//wild search with query document
//endppoint: http://localhost:5000/vareapp/find/
//type: post
// {
//   "doc": "vare_contents",
//   "search":"Micheal",
//   "key": ["fullName"]
// }

//update document
// http://localhost:5000/vareapp/update/
//post
// {
//     "keys":["item_id","user_id"],
//     "doc":"vare_vote",
//     "data": [
//         {
//             "user_id": "Shavae2006@yahoo.com",
//             "item_id": "hr6760-116",
//             "keyName": "hhhhhh"
//         }
//     ]
// }

//create single document
//endppoint: http://localhost:5000/vareapp/single/
//type: post
// {
//     "keys":"vare_vote",
//     "data": [
//         {
//             "user_id": "Shavae2006@yahoo.com",
//             "item_id": "hr6760-116",
//             "vote": "yes",
//             "Timestamp": "0000-00-00 00:00:00",
//             "installId": "ww7FB4E2EF-4722-48F2-9324-1B51468F39B0",
//             "keyName": ""
//         }
//     ]
// }

export default {
  axiosQuery: async (myRequest) => {
    const {
      dateName,
      gteDate,
      search,
      request,
      resource,
      id,
      keyName,
      check,
      query,
      orderBy,
      sortBy,
      groupBy,
      limit,
      skip,
      searchnotnull,
      inrange,
    } = myRequest;

    const urlPrefix = "https://vare-middleware.herokuapp.com";
    // const urlPrefix = "http://localhost:5003";

    // UPDATED: vareapp base (urlPrefixMiddle)
    const urlPrefixMiddle =
      "https://vdkgyobpojo5coa63qmq6wafzy0vwqdv.lambda-url.us-east-2.on.aws";
    // const urlPrefixMiddle = "http://localhost:5003";

    // var orderBy = "asc";
    var url = "";
    var data = {};
    var timestamp = `${moment().format()}`;
    var method = "post";
    var route = "";
    // alert(resource + request)

    if (request == "register") {
      // UPDATED: auth base
      url = `https://hktt33xthzmuelz6omoqwo6nja0mrcyf.lambda-url.us-east-2.on.aws/authApp/register`;
      // alert(34)

      query["installId"] = "TBD"; //Constants.installationId;
      // query["source"] = 'web'
      data = {
        doc: resource,
        data: [query ? query : {}],
      };
      method = "POST";
    } else if (request == "forgetlogin") {
      // UPDATED: auth base
      url = `https://hktt33xthzmuelz6omoqwo6nja0mrcyf.lambda-url.us-east-2.on.aws/auth/forgetlogin`;
      data = {
        doc: resource,
        data: [query ? query : {}],
      };
      method = "POST";
    } else if (request == "login") {
      // UPDATED: auth base
      url = `https://hktt33xthzmuelz6omoqwo6nja0mrcyf.lambda-url.us-east-2.on.aws/authApp/login`;
      data = {
        doc: resource,
        data: [query ? query : {}],
      };
      method = "POST";
    } else if (request == "updateprofile") {
      // UPDATED: auth base
      url = `https://hktt33xthzmuelz6omoqwo6nja0mrcyf.lambda-url.us-east-2.on.aws/auth/updateprofile`;
      data = {
        doc: resource,
        data: [query ? query : {}],
      };
      method = "POST";
    } else if (request == "read" || request == "get") {
      // UPDATED: vareapp base
      url = `https://vdkgyobpojo5coa63qmq6wafzy0vwqdv.lambda-url.us-east-2.on.aws${"/vareapp/findall?doc="}${resource}${
        sortBy ? "&sortBy=" + sortBy : ""
      }${orderBy ? "&orderBy=" + orderBy : ""}${skip ? "&skip=" + skip : ""}${
        limit ? "&limit=" + limit : ""
      }`;
      data = {};
      method = "GET";
    } else if (request == "wildsearch") {
      // UPDATED: wildsearch
      url = `https://e325fl6o6zrz74xb7uouonidwy0exbua.lambda-url.us-east-2.on.aws/wildsearch`;
      data = {
        doc: resource,
        data: [query ? query : {}],
        limit: limit || 400,
        skip,
      };
      if (dateName && gteDate) {
        data["dateName"] = dateName;
        data["gteDate"] = gteDate;
      }
      if (search) {
        data["search"] = search;
      }
      if (check) {
        data["key"] = check;
      }
      if (sortBy) data["sortBy"] = sortBy;
      if (orderBy) data["orderBy"] = orderBy;
      method = "POST";
    } else if (request == "format-html") {
      // (unchanged – not in your new-endpoints list)
      url = `https://2iaxa2o42ljjjetalxkr45uigu0zecrh.lambda-url.us-east-2.on.aws/format-html`;
      data = {
        doc: resource,
        data: [query ? query : {}],
        limit: limit || 400,
        skip,
      };
      if (dateName && gteDate) {
        data["dateName"] = dateName;
        data["gteDate"] = gteDate;
      }
      if (search) {
        data["search"] = search;
      }
      if (check) {
        data["key"] = check;
      }
      if (sortBy) data["sortBy"] = sortBy;
      if (orderBy) data["orderBy"] = orderBy;
      if (groupBy) data["groupBy"] = groupBy;
      method = "POST";
    } else if (request == "wildsearchArray") {
      // UPDATED: wildsearchArray
      // url = 'http://localhost:8000/vareapp/wildsearchArray'
      url = `https://5jd6hnzveth4iuv5cgw3fol2tu0zkstt.lambda-url.us-east-2.on.aws/wildsearchArray`;
      data = {
        doc: resource,
        data: [query ? query : {}],
        limit: limit || 400,
        skip,
      };
      if (dateName && gteDate) {
        data["dateName"] = dateName;
        data["gteDate"] = gteDate;
      }
      if (search) {
        data["search"] = search;
      }
      if (check) {
        data["key"] = check;
      }
      if (sortBy) data["sortBy"] = sortBy;
      if (orderBy) data["orderBy"] = orderBy;
      if (groupBy) data["groupBy"] = groupBy;
      method = "POST";
    } else if (request == "search") {
      // UPDATED: search
      // url = 'http://localhost:8000/vareapp/search'
      url = `https://mcepgjv3zwsov7a5dqolftzzfu0axjhj.lambda-url.us-east-2.on.aws/search`;
      data = {
        doc: resource,
        data: [query ? query : {}],
        limit: limit || 400,
        skip,
      };
      if (dateName && gteDate) {
        data["dateName"] = dateName;
        data["gteDate"] = gteDate;
      }
      if (search) {
        data["search"] = search;
      }
      if (inrange?.start && inrange?.end) {
        data["inrange"] = {
          start: inrange?.start,
          end: inrange?.end,
          key: inrange?.key,
        };
      }
      if (searchnotnull) {
        data["searchnotnull"] = true;
      }
      if (check) {
        data["key"] = check;
      }
      if (sortBy) data["sortBy"] = sortBy;
      if (orderBy) data["orderBy"] = orderBy;
      if (groupBy) data["groupBy"] = groupBy;
      method = "POST";
    } else if (request == "search" && searchnotnull) {
      // UPDATED: search (searchnotnull branch)
      // url = 'http://localhost:8000/vareapp/search'
      url = `https://mcepgjv3zwsov7a5dqolftzzfu0axjhj.lambda-url.us-east-2.on.aws/search`;
      data = {
        doc: resource,
        data: [query ? query : {}],
        limit: limit || 400,
        skip,
      };
      if (dateName && gteDate) {
        data["dateName"] = dateName;
        data["gteDate"] = gteDate;
      }
      if (search) {
        data["search"] = search;
      }
      if (searchnotnull) {
        data["searchnotnull"] = true;
      }
      if (check) {
        data["key"] = check;
      }
      if (sortBy) data["sortBy"] = sortBy;
      if (orderBy) data["orderBy"] = orderBy;
      if (groupBy) data["groupBy"] = groupBy;
      method = "POST";
    } else if (request == "searchArray") {
      // uses vareapp base
      url = `${urlPrefixMiddle}/vareapp/votes`;
      data = {
        doc: "vare_vote",
        data: query ? query : {},
      };
      method = "POST";
    } else if (request == "insert") {
      //insert (uses vareapp base)
      url = `${urlPrefixMiddle}/vareapp/update`;
      // url = 'http://localhost:5000/vareapp/update'
      query["installId"] = "TBD"; //Constants.installationId;
      data = {
        key: check, //where user_id and item_id values does not exist
        doc: resource,
        data: [query ? query : {}],
      };
      // console.log('ZZxxxx',data)
      method = "POST";
    } else if (request == "patch") {
      //edit (uses vareapp base)
      url = `${urlPrefixMiddle}/vareapp/update`;
      data = {
        key: check,
        doc: resource,
        data: [query ? query : {}],
      };
      method = "post";
    } else if (request == "delete") {
      // uses vareapp base
      url = `${urlPrefixMiddle}${"/vareapp/delete?id="}${id}&doc=${resource}`;
      data = {};
      method = "DELETE";
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(data);

    var requestOptions =
      method != "GET"
        ? {
            method: method,
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          }
        : {
            method: method,
            headers: myHeaders,
            redirect: "follow",
          };

    return fetch(url, requestOptions)
      .then(async (response) => {
        // Prefer JSON if possible
        const ct = response.headers.get("content-type") || "";
        if (ct.includes("application/json")) {
          return await response.json();
        }

        // Fallback: get text, then try to parse JSON; otherwise return raw text
        const txt = await response.text();
        try {
          return JSON.parse(txt);
        } catch {
          return txt; // some of your other endpoints may return plain text
        }
      })
      .catch((error) => {
        console.log("error", error);
        return [];
      });

    // return fetch(url, requestOptions)
    //   .then((response) => {
    //     // console.log("responseresult1", v);
    //     return response.text() || "done";
    //   })
    //   .then((result) => {
    //     // console.log("responseresult2", result);
    //     if (typeof result == "string" && !result.includes("<!DOCTYPE html>")) {
    //       return JSON.parse(result) || "done";
    //     } else {
    //       return "done";
    //     }
    //   })
    //   .catch((error) => {
    //     console.log("error", error);
    //     return [];
    //   });
  },
};

// export { axiosQuery };
